import { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { INITIAL_SELECTED_TASK } from '../constants/defaultValues';

export const TimerContext = createContext({
  todayTime: 0,
  setTodayTime: () => {},
  startTime: '',
  setStartTime: () => {},
  loading: true,
  setLoading: () => {},
  selectedTask: INITIAL_SELECTED_TASK,
  setSelectedTask: () => {},
  selectedProject: { projectId: 0, project: '', client: '' },
  setSelectedProject: () => {},
  isRunning: false,
  setRunning: () => {},
});

const TimerProvider = ({ children }) => {
  const [todayTime, setTodayTime] = useState(null); // Today's total time in milliseconds
  const [startTime, setStartTime] = useState(null); // Start time of the running task in ISO format
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null); // Selected task object
  const [selectedProject, setSelectedProject] = useState({}); // ! Selected project object
  const [isRunning, setRunning] = useState(false); // Running status of the timer

  const value = {
    todayTime,
    setTodayTime,
    startTime,
    setStartTime,
    loading,
    setLoading,
    selectedTask,
    setSelectedTask,
    selectedProject,
    setSelectedProject,
    isRunning,
    setRunning,
  };
  return <TimerContext.Provider value={value}>{children}</TimerContext.Provider>;
};

// PropsType
TimerProvider.propTypes = {
  children: PropTypes.node,
};
export default TimerProvider;
